const TOKEN_KEY = 'GUIDERUSER.token'
const ACCOUNT_KEY = 'GUIDERUSER.accountId'
const USERGROUPID_KEY = 'GUIDERUSER.userGroupId'
import { getPlatform } from '@/utils/judge'
const platFrom = getPlatform()

// token
export const setToken = (token) => {
  console.log(token, 'token')
  if (platFrom === 'wxWeb' || platFrom === 'web') {
    return sessionStorage.setItem(TOKEN_KEY, token)
  } else {
    return sessionStorage.setItem(TOKEN_KEY, token)
  }
}
export const getToken = () => {
  if (platFrom === 'wxWeb' || platFrom === 'web') {
    return sessionStorage.getItem(TOKEN_KEY)
  } else {
    return sessionStorage.getItem(TOKEN_KEY)
  }
}

// accountId
export const setAccountId = (token) => {
  if (platFrom === 'wxWeb' || platFrom === 'web') {
    return sessionStorage.setItem(ACCOUNT_KEY, token)
  } else {
    return sessionStorage.setItem(ACCOUNT_KEY, token)
  }
}
export const getAccountId = () => {
  if (platFrom === 'wxWeb' || platFrom === 'web') {
    return sessionStorage.getItem(ACCOUNT_KEY)
  } else {
    return sessionStorage.getItem(ACCOUNT_KEY)
  }
}

// userGroupId
export const setUserGroupId = (userGroupId) => {
  if (platFrom === 'wxWeb' || platFrom === 'web') {
    return localStorage.setItem(USERGROUPID_KEY, userGroupId)
  } else {
    return sessionStorage.setItem(USERGROUPID_KEY, userGroupId)
  }
}
export const getUserGroupId = () => {
  if (platFrom === 'wxWeb' || platFrom === 'web') {
    return localStorage.getItem(USERGROUPID_KEY)
  } else {
    return sessionStorage.getItem(USERGROUPID_KEY)
  }
}
